import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ColorSchemeService } from 'src/app/services/color-scheme.service';

@Component({
  selector: 'app-learn-free-courses',
  templateUrl: './learn-free-courses.component.html',
  styleUrls: ['./learn-free-courses.component.scss']
})
export class LearnFreeCoursesComponent {
  @Input() course: any;
  @Input() videos: any[] = [];
  @Input() volume: any = null;
  @Input() showScrollbar = false;
  @Input() fitContent = false;
  @Input() maxItemsPerRow = 0; // can be a value between 1 and 5, 0 for not set
  @Input() isLearnToFlyCoursePaid = false;

  constructor(private router: Router, public colorSchemeService: ColorSchemeService) { }

  goToVideo(video) {
    this.router.navigate(['course/PRIVATE/volumes/VIDEO_TRAINING/', this.volume?.uuid, video.uuid]);
  }

  viewAllVideos() {
    this.router.navigate(['course/PRIVATE/volumes/VIDEO_TRAINING/', this.volume?.uuid]);
  }
}
